<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <template v-slot:header>
                <h5>Input Banner Mobile</h5>
            </template>
            <b-form @submit.prevent="$bvModal.show('modal-confirm')">
                <div class="form-content-wrapper mb-0">
                    <b-form-group label="Judul">
                        <b-form-input v-model="input.judul" maxlength="255" required />
                    </b-form-group>
                    <b-form-group label="Teks">
                        <b-form-textarea v-model="input.teks" maxlength="2000" rows="4" max-rows="8" required />
                        <template v-slot:description>
                            <div class="small text-muted">
                                {{ input.teks.length }} / 2000 karakter
                            </div>
                        </template>
                    </b-form-group>
                    <b-form-group label="Foto Banner">
                        <b-form-file v-model="input.photo" accept="image/*" />
                        <template v-slot:description>
                            <div class="text-muted">
                                Kosongkan bila tidak ingin merubah foto. 
                                <a :href="$baseFilePath + input.currentPhotoPath" target="_blank">Lihat Foto Sekarang</a>
                            </div>
                        </template>
                    </b-form-group>
                    <b-form-group label="Tautan / Link Tambahan (Opsional)" description="Tambahan tautan untuk navigasi pengguna selanjutnya (contoh: website PGI)">
                        <b-form-input v-model="input.link" maxlength="255" />
                    </b-form-group>
                    <b-button type="submit" variant="pgiBtn">
                        Simpan
                    </b-button>
                </div>
            </b-form>
        </b-card>
        <b-modal id="modal-confirm" title="Konfirmasi" centered hide-footer no-close-on-backdrop no-close-on-esc>
            Ubah banner dengan data terbaru ini?
            <div class="text-right mt-4">
                <b-button variant="pgiBtn" :disabled="isSubmitting" @click="execEditBanner">
                    {{ isSubmitting ? "Mengubah..." : "Ubah" }}
                </b-button>
            </div>
        </b-modal>
    </div>
</template>

<script>
export default {
    name: 'banner-mobile-edit',
    data() {
        return {

            initStatus: 0,
            isSubmitting: false,
            
            input: {
                judul: "",
                teks: "",
                photo: null,
                link: "",
                currentPhotoPath: ""
            },

            dtl: {}

        }
    },
    methods: {

        init() {

            this.initStatus = 0

            let getDetail = this.$axios.get("banner-mobile/" + this.$route.params.id).then(res => {

                let data = res.data
                this.input.judul = data.judul
                this.input.teks = data.teks
                this.input.link = data.link || ""
                this.input.currentPhotoPath = data.photo

            })

            Promise.all([getDetail]).then(() => {
                this.initStatus = 1
            })
            .catch(error => {
                console.log(error)
                this.initStatus = -1
            })

        },

        execEditBanner() {

            let payload = new FormData()
            payload.append("id", this.$route.params.id)
            payload.append("judul", this.input.judul)
            payload.append("teks", this.input.teks)
            
            if(this.input.photo != null) {
                payload.append("photo", this.input.photo)
            }
            
            if(!this.$helper.isNullOrEmpty(this.input.link)) {
                payload.append("link", this.input.link)
            }

            this.isSubmitting = true
            this.$axios.post("banner-mobile/", payload).then(res => {
                this.$helper.setFlash("Banner berhasil diubah!")
                this.$router.push("/master/banner-mobile/" + res.data.id)
            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },  

    },
    created() {
        this.init()
    }
}
</script>